import { FC, useEffect, useMemo, useState } from "react";
import SelectTable from '../SelectTable';
import SuperCascader from '../SuperCascader';
import FormItem from './subpage/formItem';
import SearchFormItem from './subpage/searchFormItem';
import SearchFormDisabled from './subpage/disabled';
import {
  BaseSearchFormItemProps,
  SearchFormItemEnum,
} from './interface/baseInterface';
import { SelectTableProps } from '../SelectTable';
import { SuperCascaderProps } from '../SuperCascader/interface';
import { FormItemProps } from 'antd/lib/form';
import { getSelectPlaceholder } from "../utils/ruleUtils";

export interface SearchFormSelectGroupTableProps extends BaseSearchFormItemProps {
  /** 前置表单配置 */
  beforeFormItemProps?: FormItemProps;
  /** 后置表单配置 */
  afterFormItemProps?: FormItemProps;
  /** 前置下拉分类框配置 */
  beforeCascaderProps?: SuperCascaderProps;
  /** 后置下拉框配置 */
  afterSelectTableProps?: SelectTableProps;
  /** 是否禁用 */
  disabled?: boolean;
  /** 前置选中后的值后于后置的搜索参数名称 */
  searchName?: string;
};
/** 下拉分类+下拉列表 */
const SearchFormSelectGroupTable: FC<SearchFormSelectGroupTableProps> = props => {
  const {
    label, isDetail, required, disabled, testId, render, isTable,
    form, beforeFormItemProps, afterFormItemProps, disabledRender, searchName,
    beforeCascaderProps, afterSelectTableProps, name, ...restProps
  } = props;
  const [beforeValue, setBeforeValue] = useState<string>(beforeFormItemProps?.initialValue);
  useEffect(() => {
    setTimeout(() => {
      const beforeName = beforeFormItemProps?.name;
      if (form && beforeName) {
        let newBeforeValue = form.getFieldValue(beforeName);
        newBeforeValue && setBeforeValue(newBeforeValue);
      }
    }, 200);
  }, []);
  const handleBeforeSelect = (value: any, selectedOption: any) => {
    const afterName = afterFormItemProps?.name;
    setBeforeValue(value);
    beforeCascaderProps?.onSelect?.(value, selectedOption);
    afterName && typeof afterName === 'string' && form?.setFieldsValue({[afterName]: undefined});
  };
  const otherParams = useMemo(() => {
    const afterSearchName = searchName || beforeFormItemProps?.name;
    if (typeof afterSearchName === 'string') return {[afterSearchName]: beforeValue};
  }, [beforeValue]);
  const normFile = (e: any) => {
    if (beforeCascaderProps?.multiple) {
      return e.map?.((item: any) => item?.slice?.(-1)?.[0])
    }
    if (e && e.length) return e.slice?.(-1)?.[0];
    return undefined;
  };
  return (
    <SearchFormItem
      {...restProps}
      label={label}
      disabled={isDetail}
      className={required ? 'address-required' : ''}
    >
      {
        isDetail || disabled ? (
          <SearchFormDisabled
            form={form}
            render={render || disabledRender}
            isTable={isTable}
          />
        ) : (
          <div className="yb-group-select">
            {
              beforeCascaderProps && (
                <FormItem
                  style={{width: '50%'}}
                  {...beforeFormItemProps}
                  test-id={`${testId}-${beforeFormItemProps?.name}`}
                  hideLabel={true}
                  label={beforeFormItemProps?.label}
                  form={form}
                  valuePropName="cascaderValue"
                  getValueFromEvent={normFile}
                >
                  <SuperCascader
                    allowClear
                    className="yb-group-select-before"
                    {...beforeCascaderProps}
                    placeholder={getSelectPlaceholder(beforeFormItemProps?.label ?? '仓库', beforeCascaderProps, beforeFormItemProps?.rules)}
                    onSelect={handleBeforeSelect}
                  />
                </FormItem>
              )
            }
            {
              afterSelectTableProps && (
                <FormItem
                  style={{width: '50%'}}
                  {...afterFormItemProps}
                  test-id={`${testId}-${afterFormItemProps?.name}`}
                  hideLabel={true}
                  label={afterFormItemProps?.label}
                  form={form}
                >
                  <SelectTable
                    style={{width: '100%'}}
                    className="yb-group-select-after"
                    {...afterSelectTableProps}
                    placeholder={getSelectPlaceholder(afterFormItemProps?.label ?? '卖家', afterSelectTableProps, afterFormItemProps?.rules)}
                    disabled={!beforeValue}
                    otherParams={otherParams}
                  />
                </FormItem>
              )
            }
          </div>
        )
      }
    </SearchFormItem>
  );
};

SearchFormSelectGroupTable.displayName = SearchFormItemEnum.SearchFormSelectGroupTable;

export default SearchFormSelectGroupTable;
